import * as Yup from 'yup';
import { validUSState } from 'common/helpers/yup-helpers';
import { usesBrandInterestedPartyTypes } from 'common/helpers/auto-interested-party-helpers';

Yup.addMethod(Yup.mixed, 'validUSState', validUSState);

// #36264: a brand-typed party (CFM) must name its relationship and at least one vehicle; the legacy
// single-vehicle rules below stay as they were for Branch.
const brandTypedSchema = Yup.object().shape({
  name: Yup.string().required('Name or Company is required!'),
  relationship: Yup.string().required('Relationship is required!'),
  address: Yup.string().ensure().required('Address is required!'),
  address2: Yup.string().nullable(),
  city: Yup.string().nullable(),
  state: Yup.string().nullable().validUSState('lienholder.state'),
  zip: Yup.string().nullable(),
  loanNumber: Yup.string().nullable(),
  trusteeNames: Yup.string().nullable(),
  VINs: Yup.array().of(Yup.string()).min(1, 'Select at least one vehicle!')
});

const legacySchema = Yup.object().shape({
  name: Yup.string().required('Name or Company is required!'),
  address: Yup.string().ensure().required('Address is required!'),
  address2: Yup.string().nullable(),
  city: Yup.string().nullable(),
  state: Yup.string().nullable().validUSState('lienholder.state'),
  zip: Yup.string().nullable(),
  loanNumber: Yup.string().nullable(),
  VIN: Yup.string()
    .nullable()
    .test('Select Associated Entity', 'Invalid Relationship Selection', (value, context) => {
      if (context?.parent?.relationship === 'renters' && value === 'renters') {
        return true;
      }
      if (context?.parent?.relationship === 'lienholder' && value !== 'renters') {
        return true;
      }
      if (context?.parent?.relationship === 'lessor') {
        return true;
      }
      return false;
    })
    .when('relationship', {
      is: 'lessor',
      then: Yup.string().required('Assoicated entity is required!')
    })
});

// Resolved at validate time so the schema tracks the active brand (the flag is a build-time constant
// in the app, a mutable mock in tests).
export const validationSchema = Yup.lazy(() => (usesBrandInterestedPartyTypes() ? brandTypedSchema : legacySchema));
